module.exports = __webpack_public_path__ + "static/media/overdueNA.6666182b.svg";